module.exports = __webpack_public_path__ + "img/icon_play_fullscreen.d72553e0.png";